import { createAction, props } from '@ngrx/store';
import { IInviteStatus } from '../models/invite-status.model';

export const loadInviteStatus = createAction('[InviteStatus] Load InviteStatus');

export const loadInviteStatusSuccess = createAction('[InviteStatus] Load InviteStatus Success', props<{ response: IInviteStatus[] }>());

export const loadInviteStatusFailure = createAction('[InviteStatus] Load InviteStatus Failure', props<{ error: Error | any }>());
